import React from 'react'
import PageWrapper from '../Components/Other/PageWrapper'
import PageBanner from '../Components/Other/PageBanner'
function RefundsNCancellation(props) {
    return (
        <PageWrapper className={"blog-page"}>
            <div className="pageWrapper">
                <PageBanner pageName={"Refunds And Cancellation"}></PageBanner>
                <div className="MainContent">
                    <div className="container">
                        <div className="page-rte">
                            <p>
                                <b>Cancellation</b>
                                <br />
                                Cancellations will be considered only if the request is made within 48 hours of
                                placing an appointment. If patient want to change date of appointment he/she
                                should inform us prior 7 days of defined date.
                                <br /><br />
                                <b>Refund</b>
                                <br />
                                For any reason you want to cancel appointment, we cheerfully refund whole
                                amount if cancellation is done within 48 hours. Refunds are being processed
                                within 21 days period.
                            </p>
                        </div>
                    </div>
                </div>
            </div>


        </PageWrapper>
    );
}

export default RefundsNCancellation
    ;